/*
  import { mailingEventStore } from '@/services/MailingManagement/MailEvents/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import { notifyProblem } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await mailingEventStore.dispatch ('getMailingEventList', {
      mailingDeliveryItemID
    });
  */
  async getMailingEventList({}, { mailingDeliveryItemID }) {
    console.log('in getMailingEventList...' + mailingDeliveryItemID)
    try {
      const result = await kms.get('/Mailings/MailingDeliveryItemEvent/List', {
        params: {
          mailingDeliveryItemID
        }
      })

      if (isDebug == true) console.debug('getMailingEventList log=' + JSON.stringify(result))

      return {
        list: result.results
      }
    } catch (exception) {
      notifyProblem(`The mailing delievery item event list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const mailingEventStore = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
